import React, { useContext } from 'react'
import Modal from '../components/Modal'
import { ContentStackTypes, ModalTypes, UserOs } from '../store/Constants'
import { ANALYTICS } from '../store/AnalyticsConstants'
import classes from './TroubleInstallingModal.module.scss'
import { ConfigContext } from '../store/ConfigContext'

const TroubleInstallingModal = ({ open, onClose, showFooter }) => {
  const { isMobile, os } = useContext(ConfigContext)
  const getContentType = () => {
    if (isMobile) {
      return ContentStackTypes.trouble_installing_modal_mobile
    }
    return os === UserOs.mac
      ? ContentStackTypes.trouble_installing_modal_desktop_mac
      : ContentStackTypes.trouble_installing_modal_desktop_win
  }

  return (
    <Modal
      className={classes.troubleInstallingModalContainer}
      show={open}
      contentType={getContentType()}
      primaryClick={isMobile ? null : onClose}
      onClose={onClose}
      closeButton={true}
      showFooter={showFooter}
      analytics={{
        screen: ANALYTICS.MODALS.TROUBLE_INSTALLING,
        primary_button: ANALYTICS.BUTTONS.CLOSE_TROUBLE_INSTALLING,
        close_button: ANALYTICS.BUTTONS.CLOSE_TROUBLE_INSTALLING
      }}
      type={ModalTypes.trouble_installing}
    >
      {({ pageData }) =>
        pageData.map(({ data }, i) => (
          <div key={i} dangerouslySetInnerHTML={{ __html: data }} />
        ))
      }
    </Modal>
  )
}

export default TroubleInstallingModal
